// Generated by Avo VERSION 123.55.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "NAdbdeXez6PC7vGWSIDf";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "PaZDqt0qeUMPM0rC4g0I",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "bJ0pj2RVS0ir3Kh8P6lq",
          "se": (new Date()).toISOString(),
          "so": "dUG53Ficd",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "PaZDqt0qeUMPM0rC4g0I",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "bJ0pj2RVS0ir3Kh8P6lq",
          "se": (new Date()).toISOString(),
          "so": "dUG53Ficd",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "bJ0pj2RVS0ir3Kh8P6lq",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface SOFAResourceUpdates {
  sofaResourceType: SOFAResourceTypeValueType
  amount: number
}

export interface SOFAResourceInventory {
  sofaResourceType: SOFAResourceTypeValueType
  amount: number
}

export interface SOFALevelMetricsCount {
  sofaLevelMetric: SOFALevelMetricValueType
  amount: number
}

export interface MetaProperties {
  metaPropertyName: string
  metaPropertyValue: string
}

export const GameSlug = {
  'UNSPECIFIED': 'unspecified',
  '2020_CONNECT': '2020-connect',
  'BEST_CLASSIC_MAHJONG_CONNECT': 'best-classic-mahjong-connect',
  'BUBBLE_SHOOTER_BLITZ': 'bubble-shooter-blitz',
  'INFINITE_BULLETS': 'infinite-bullets',
  'PUZZLE_BLOCKS': 'puzzle-blocks',
  'DAILY_SOLITAIRE': 'daily-solitaire',
  'JEWELS_BLITZ_FB': 'jewels-blitz-fb',
  'BUBBLE_SHOOTER_CLASSIC': 'bubble-shooter-classic',
  'MOJI': 'moji',
  'SOLITAIRE_GARDEN': 'solitaire-garden',
  'JEWELS_BLITZ_X': 'jewels-blitz-x',
  'YUMMY_TALES': 'yummy-tales',
  'BEST_CLASSIC_PYRAMID_SOLITAIRE': 'best-classic-pyramid-solitaire',
  'BEST_CLASSIC_SPIDER_SOLITAIRE': 'best-classic-spider-solitaire',
  'MY_LITTLE_GARDEN': 'my-little-garden',
  'FOREST_MATCH': 'forest-match',
  'SOLITAIRE_TRIPEAKS': 'solitaire-tripeaks',
  'BUBBLE_SHOOTER_PRO': 'bubble-shooter-pro',
  'SOLITAIRE_HOME_STORY': 'solitaire-home-story',
  'SOLITAIRE_HOME_STORY_MOBILE': 'solitaire-home-story-mobile',
  'SG_SOLITAIRE_CLASSIC': 'sg-solitaire-classic',
  'SOLITAIRE_MAHJONG_CLASSIC_2': 'solitaire-mahjong-classic-2',
  'TILE_QUEST': 'tile-quest',
  'SOLITAIRE_FARM_SEASONS': 'solitaire-farm-seasons',
  'SOLITAIRE_HOME_STORY_WEB': 'solitaire-home-story-web',
  'PUZZLE_BLOCKS_MOBILE': 'puzzle-blocks-mobile',
  'POP_IT': 'pop-it',
  'MATCH_3_GARDEN': 'match-3-garden',
  'CANDY_MATCH': 'candy-match',
  'FISH_STORY': 'fish-story',
  'CANDY_RAIN_5': 'candy-rain-5',
  'GARDEN_TALES': 'garden-tales',
  'COOKIE_CRUSH_2': 'cookie-crush-2',
} as const;
export type GameSlugType = typeof GameSlug;
export type GameSlugValueType = GameSlugType[keyof GameSlugType];

export const PurchaseResponse = {
  'SUCCESS': 'Success',
  'ERROR': 'Error',
} as const;
export type PurchaseResponseType = typeof PurchaseResponse;
export type PurchaseResponseValueType = PurchaseResponseType[keyof PurchaseResponseType];

export const ResourceActionType = {
  'PURCHASE': 'Purchase',
  'REWARD': 'Reward',
  'AD': 'Ad',
  'INVENTORY': 'Inventory',
  'COIN_PURCHASE': 'Coin_Purchase',
  'TICKET_PURCHASE': 'Ticket_Purchase',
} as const;
export type ResourceActionTypeType = typeof ResourceActionType;
export type ResourceActionTypeValueType = ResourceActionTypeType[keyof ResourceActionTypeType];

export const AdNetwork = {
  'FACEBOOK': 'facebook',
  'UNITY': 'unity',
  'APP_LOVIN': 'appLovin',
  'SOFTGAMES': 'softgames',
  'AD_MOB': 'adMob',
} as const;
export type AdNetworkType = typeof AdNetwork;
export type AdNetworkValueType = AdNetworkType[keyof AdNetworkType];

export const PaymentProvider = {
  'FACEBOOK': 'facebook',
  'APPLE': 'apple',
  'GOOGLEPLAY': 'googleplay',
} as const;
export type PaymentProviderType = typeof PaymentProvider;
export type PaymentProviderValueType = PaymentProviderType[keyof PaymentProviderType];

export const AdResponse = {
  'SUCCESS': 'Success',
  'CLOSED': 'Closed',
  'ERROR': 'Error',
  'SKIPPED': 'Skipped',
} as const;
export type AdResponseType = typeof AdResponse;
export type AdResponseValueType = AdResponseType[keyof AdResponseType];

export const PlatformName = {
  'FACEBOOK': 'facebook',
  'GOOGLE_PLAY_STORE': 'google play store',
  'IOS_APP_STORE': 'ios app store',
  'MS_APP_STORE': 'ms app store',
  'SAMSUNG': 'samsung',
  'WEB': 'web',
} as const;
export type PlatformNameType = typeof PlatformName;
export type PlatformNameValueType = PlatformNameType[keyof PlatformNameType];

export const LevelResult = {
  'SUCCESS': 'Success',
  'FAILED': 'Failed',
} as const;
export type LevelResultType = typeof LevelResult;
export type LevelResultValueType = LevelResultType[keyof LevelResultType];

export const BackendName = {
  'FIREBASE': 'firebase',
  'SOFTGAMES': 'softgames',
  'PLAYFAB': 'playfab',
} as const;
export type BackendNameType = typeof BackendName;
export type BackendNameValueType = BackendNameType[keyof BackendNameType];

export const Environment = {
  'PROD': 'prod',
  'DEV': 'dev',
} as const;
export type EnvironmentType = typeof Environment;
export type EnvironmentValueType = EnvironmentType[keyof EnvironmentType];

export const ProductType = {
  'CONSUMABLE': 'Consumable',
  'SUBSCRIBABLE': 'Subscribable',
} as const;
export type ProductTypeType = typeof ProductType;
export type ProductTypeValueType = ProductTypeType[keyof ProductTypeType];

export const SchemaVersion = {
  '65': '65',
} as const;
export type SchemaVersionType = typeof SchemaVersion;
export type SchemaVersionValueType = SchemaVersionType[keyof SchemaVersionType];

export const SOFALevelMetric = {
  'CARDS_LEFT_ON_BOARD': 'Cards Left on Board',
  'CARDS_LEFT_IN_STACK': 'Cards Left in Stack',
  'STARS_ACHIEVED': 'Stars Achieved',
} as const;
export type SOFALevelMetricType = typeof SOFALevelMetric;
export type SOFALevelMetricValueType = SOFALevelMetricType[keyof SOFALevelMetricType];

export const SOFAResourceType = {
  'COINS': 'Coins',
  'BOOSTER_JOKER': 'Booster Joker',
  'BOOSTER_UNDO': 'Booster Undo',
  'BOOSTER_PLUS_5_CARDS': 'Booster Plus 5 Cards',
  'BOOSTER_CANISTER': 'Booster Canister',
  'BOOSTER_SLINGSHOT': 'Booster Slingshot',
  'BOOSTER_SHUFFLE': 'Booster Shuffle',
  'BOOSTER_PRE_LEVEL_REMOVE_THREE': 'Booster Pre-level Remove Three',
  'BOOSTER_PRE_LEVEL_JOKER': 'Booster Pre-level Joker',
  'BOOSTER_PRE_LEVEL_CANISTER': 'Booster Pre-level Canister',
  'FREE_LEVEL_ENTRY': 'Free Level Entry',
} as const;
export type SOFAResourceTypeType = typeof SOFAResourceType;
export type SOFAResourceTypeValueType = SOFAResourceTypeType[keyof SOFAResourceTypeType];

export const AdType = {
  'INTERSTITIAL': 'Interstitial',
  'REWARDED': 'Rewarded',
  'REWARDED_INTERSTITIAL': 'Rewarded Interstitial',
} as const;
export type AdTypeType = typeof AdType;
export type AdTypeValueType = AdTypeType[keyof AdTypeType];

let sysSessionId: any;
let sysGameSlug: any;
let sysGameVersion: any;
let sysPlatformName: any;
let sysSchemaVersion: any;
let sysEnvironment: any;

export function setSystemProperties(properties: {sessionId: string;
  gameSlug: GameSlugValueType; gameVersion: string;
  platformName: PlatformNameValueType; schemaVersion: SchemaVersionValueType;
  environment: EnvironmentValueType}) {
  if (properties.sessionId !== null && properties.sessionId !== undefined) {
    sysSessionId = properties.sessionId;
  }
  if (properties.gameSlug !== null && properties.gameSlug !== undefined) {
    sysGameSlug = properties.gameSlug;
  }
  if (properties.gameVersion !== null && properties.gameVersion !== undefined) {
    sysGameVersion = properties.gameVersion;
  }
  if (properties.platformName !== null && properties.platformName !== undefined) {
    sysPlatformName = properties.platformName;
  }
  if (properties.schemaVersion !== null && properties.schemaVersion !== undefined) {
    sysSchemaVersion = properties.schemaVersion;
  }
  if (properties.environment !== null && properties.environment !== undefined) {
    sysEnvironment = properties.environment;
  }
}

let Softgames: any;

export function initAvo(options: {env: AvoEnv; webDebugger?: boolean;
  webDebuggerOptions?: webDebuggerOptions; strict?: boolean; noop?: boolean;
  reportFailureAs?: 'error' | 'warn' | 'log'; inspector?: AvoInspector;
  avoLogger?: AvoLogger}, systemProperties: {sessionId: string;
  gameSlug: GameSlugValueType; gameVersion: string;
  platformName: PlatformNameValueType; schemaVersion: SchemaVersionValueType;
  environment: EnvironmentValueType}, destinationOptions: any,
  SoftgamesDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }

  setSystemProperties(systemProperties);

  destinationOptions = destinationOptions || {};

  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }

    Softgames = SoftgamesDestination;
    if (__AVO_ENV__ === 'prod') {
      Softgames && Softgames.make && Softgames.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      Softgames && Softgames.make && Softgames.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Softgames. Head to destination settings in Avo to set a staging key.");
      Softgames && Softgames.make && Softgames.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertSOFAResourceUpdates(
  sofaResourceUpdates: SOFAResourceUpdates[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList("-_93HnCW2", "SOFA Resource Updates", sofaResourceUpdates));
  if (sofaResourceUpdates !== null && sofaResourceUpdates !== undefined && sofaResourceUpdates.forEach) {
    sofaResourceUpdates.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("-_93HnCW2", "item at index " + index + " in SOFA Resource Updates", value));
    });
  }
  return messages;
}

function assertSOFAResourceUpdatesOptional(
  sofaResourceUpdates: SOFAResourceUpdates[] | null | undefined,
  _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (sofaResourceUpdates !== undefined && sofaResourceUpdates !== null) {
    messages = messages.concat(AvoAssert.assertList("-_93HnCW2", "SOFA Resource Updates", sofaResourceUpdates));
    sofaResourceUpdates.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("-_93HnCW2", "item at index " + index + " in SOFA Resource Updates", value));
    });
  }
  return messages;
}

function assertSOFAResourceInventory(
  sofaResourceInventory: SOFAResourceInventory[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList("4tzAI4lGQ", "SOFA Resource Inventory", sofaResourceInventory));
  if (sofaResourceInventory !== null && sofaResourceInventory !== undefined && sofaResourceInventory.forEach) {
    sofaResourceInventory.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("4tzAI4lGQ", "item at index " + index + " in SOFA Resource Inventory", value));
    });
  }
  return messages;
}

function assertSOFALevelMetricsCount(
  sofaLevelMetricsCount: SOFALevelMetricsCount[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList("RyMggSXMA", "SOFA Level Metrics Count", sofaLevelMetricsCount));
  if (sofaLevelMetricsCount !== null && sofaLevelMetricsCount !== undefined && sofaLevelMetricsCount.forEach) {
    sofaLevelMetricsCount.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("RyMggSXMA", "item at index " + index + " in SOFA Level Metrics Count", value));
    });
  }
  return messages;
}

function assertMetaPropertiesOptional(
  metaProperties: MetaProperties[] | null | undefined, _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (metaProperties !== undefined && metaProperties !== null) {
    messages = messages.concat(AvoAssert.assertList("tV7TWP7c1", "Meta Properties", metaProperties));
    metaProperties.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("tV7TWP7c1", "item at index " + index + " in Meta Properties", value));
    });
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface GameInitializedProperties {
  browserName: string | null | undefined;
  browserVersion: string | null | undefined;
  systemLocale: string | null | undefined;
  osName: string | null | undefined;
  osVersion: string | null | undefined;
  timeZoneName: string | null | undefined;
  timeZone: number | null | undefined;
  deviceType: string | null | undefined;
  deviceVendor: string | null | undefined;
  deviceModel: string | null | undefined;
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  newPlayer: boolean;
  entryPointName: string | null | undefined;
  timeSinceStartup: number | null | undefined;
  backendName: BackendNameValueType | null | undefined;
  backendUserId: string | null | undefined;
  profileId: string;
  platformUserId: string | null | undefined;
  sessionCounter: number | null | undefined;
  entryPointData: string | null | undefined;
  userFingerprint: string | null | undefined;
  maxTextureSize: number | null | undefined;
  affiliateId: string | null | undefined;
}
/**
 * Game Initialized: Fires after the game connected to the backend and finished the initialisation of the player profile.
 *
 * @param properties the properties associatied with this event
 * @param properties.browserName: The browser name as provided by the user agent.
 * @param properties.browserVersion: The browser version as provided by the user agent.
 * @param properties.systemLocale: System locale of the device
 * @param properties.osName: Name of the operating system
 * @param properties.osVersion: Operating system version
 * @param properties.timeZoneName: Name of the zone (AEST etc..)
 * @param properties.timeZone: UTC time zone (-3, +2 etc..)
 * @param properties.deviceType: Type of the device
 * @param properties.deviceVendor: Vendor of the device
 * @param properties.deviceModel: Model specification of the device (high variance,  needs to be grouped/standardized in backend)
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.newPlayer: Indicates whether a user is playing for the first time
 * @param properties.entryPointName: Entry point as returned by the FB SDK
 * @param properties.timeSinceStartup: Time in seconds from moment the game has started until the current event is sent.
 * @param properties.backendName: The authentication backend where the user profile is stored.
 * @param properties.backendUserId: The user ID on the backend where the user profile is stored (associated with 'Backend Name' property)
 * @param properties.profileId: Unique tracking Id for the user that must be persisted in the user profile. This is generated on the client on first start, when the profile is created. It is NOT the facebook or game backend user ID.
 * @param properties.platformUserId: User Id given by the respective publishing platform (e.g. Facebook, Google Play, iOS Appstore, etc)
 * @param properties.sessionCounter: Incremental session counter, persisted in the player profile.
 * @param properties.entryPointData: JSON object with specific entry point properties as returned by the FB SDK
 * @param properties.userFingerprint: A unique identifier for a user to track users across games, typically based on a salted hash of the user email.
 * @param properties.maxTextureSize: The largest supported texture size as returned by the WebGLRenderingContext using getParameter(gl.MAX_TEXTURE_SIZE)

https://registry.khronos.org/webgl/specs/latest/1.0/#5.14.3
 * @param properties.affiliateId: The Id of the affiliate by which the user entered the game for the first time
 *
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/mdZU_5FwjxP}
 */
export function gameInitialized(properties: GameInitializedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.browserName !== undefined && properties.browserName !== null ?
    eventPropertiesArray.push({id: "PvkE4N5RmG", name: "Browser Name", value: properties.browserName}) :
    eventPropertiesArray.push({id: "PvkE4N5RmG", name: "Browser Name", value: null});
  properties.browserVersion !== undefined && properties.browserVersion !== null ?
    eventPropertiesArray.push({id: "1zFX7Qgmr_", name: "Browser Version", value: properties.browserVersion}) :
    eventPropertiesArray.push({id: "1zFX7Qgmr_", name: "Browser Version", value: null});
  properties.systemLocale !== undefined && properties.systemLocale !== null ?
    eventPropertiesArray.push({id: "I94Xksxdd4", name: "System Locale", value: properties.systemLocale}) :
    eventPropertiesArray.push({id: "I94Xksxdd4", name: "System Locale", value: null});
  properties.osName !== undefined && properties.osName !== null ?
    eventPropertiesArray.push({id: "CAGTeR9Kq0", name: "OS Name", value: properties.osName}) :
    eventPropertiesArray.push({id: "CAGTeR9Kq0", name: "OS Name", value: null});
  properties.osVersion !== undefined && properties.osVersion !== null ?
    eventPropertiesArray.push({id: "xgwj56YMz", name: "OS Version", value: properties.osVersion}) :
    eventPropertiesArray.push({id: "xgwj56YMz", name: "OS Version", value: null});
  properties.timeZoneName !== undefined && properties.timeZoneName !== null ?
    eventPropertiesArray.push({id: "yEjy5yIpg6", name: "Time Zone Name", value: properties.timeZoneName}) :
    eventPropertiesArray.push({id: "yEjy5yIpg6", name: "Time Zone Name", value: null});
  properties.timeZone !== undefined && properties.timeZone !== null ?
    eventPropertiesArray.push({id: "OAi3oEvLFt", name: "Time Zone", value: properties.timeZone}) :
    eventPropertiesArray.push({id: "OAi3oEvLFt", name: "Time Zone", value: null});
  properties.deviceType !== undefined && properties.deviceType !== null ?
    eventPropertiesArray.push({id: "TiC6ymZVUi", name: "Device Type", value: properties.deviceType}) :
    eventPropertiesArray.push({id: "TiC6ymZVUi", name: "Device Type", value: null});
  properties.deviceVendor !== undefined && properties.deviceVendor !== null ?
    eventPropertiesArray.push({id: "wm_ot_7-pU", name: "Device Vendor", value: properties.deviceVendor}) :
    eventPropertiesArray.push({id: "wm_ot_7-pU", name: "Device Vendor", value: null});
  properties.deviceModel !== undefined && properties.deviceModel !== null ?
    eventPropertiesArray.push({id: "rB4xlS-LDe", name: "Device Model", value: properties.deviceModel}) :
    eventPropertiesArray.push({id: "rB4xlS-LDe", name: "Device Model", value: null});
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "vRDzqTLnQK", name: "New Player", value: properties.newPlayer});
  properties.entryPointName !== undefined && properties.entryPointName !== null ?
    eventPropertiesArray.push({id: "xJRXoM1u9_", name: "Entry Point Name", value: properties.entryPointName}) :
    eventPropertiesArray.push({id: "xJRXoM1u9_", name: "Entry Point Name", value: null});
  properties.timeSinceStartup !== undefined && properties.timeSinceStartup !== null ?
    eventPropertiesArray.push({id: "SSRyFPUR3-", name: "Time Since Startup", value: properties.timeSinceStartup}) :
    eventPropertiesArray.push({id: "SSRyFPUR3-", name: "Time Since Startup", value: null});
  properties.backendName !== undefined && properties.backendName !== null ?
    eventPropertiesArray.push({id: "k7RcwDqCeH", name: "Backend Name", value: properties.backendName}) :
    eventPropertiesArray.push({id: "k7RcwDqCeH", name: "Backend Name", value: null});
  properties.backendUserId !== undefined && properties.backendUserId !== null ?
    eventPropertiesArray.push({id: "jZsMoOtc70", name: "Backend User Id", value: properties.backendUserId}) :
    eventPropertiesArray.push({id: "jZsMoOtc70", name: "Backend User Id", value: null});
  eventPropertiesArray.push({id: "65oO39qmo5", name: "Profile Id", value: properties.profileId});
  properties.platformUserId !== undefined && properties.platformUserId !== null ?
    eventPropertiesArray.push({id: "Ck6Iwq-4GU", name: "Platform User Id", value: properties.platformUserId}) :
    eventPropertiesArray.push({id: "Ck6Iwq-4GU", name: "Platform User Id", value: null});
  properties.sessionCounter !== undefined && properties.sessionCounter !== null ?
    eventPropertiesArray.push({id: "bxw6NnSnSk", name: "Session Counter", value: properties.sessionCounter}) :
    eventPropertiesArray.push({id: "bxw6NnSnSk", name: "Session Counter", value: null});
  properties.entryPointData !== undefined && properties.entryPointData !== null ?
    eventPropertiesArray.push({id: "omyftFoKIG", name: "Entry Point Data", value: properties.entryPointData}) :
    eventPropertiesArray.push({id: "omyftFoKIG", name: "Entry Point Data", value: null});
  properties.userFingerprint !== undefined && properties.userFingerprint !== null ?
    eventPropertiesArray.push({id: "LNLNJe171", name: "User Fingerprint", value: properties.userFingerprint}) :
    eventPropertiesArray.push({id: "LNLNJe171", name: "User Fingerprint", value: null});
  properties.maxTextureSize !== undefined && properties.maxTextureSize !== null ?
    eventPropertiesArray.push({id: "mgQxv84TU", name: " Max Texture Size", value: properties.maxTextureSize}) :
    eventPropertiesArray.push({id: "mgQxv84TU", name: " Max Texture Size", value: null});
  properties.affiliateId !== undefined && properties.affiliateId !== null ?
    eventPropertiesArray.push({id: "NKgHAojT9", name: "Affiliate Id", value: properties.affiliateId}) :
    eventPropertiesArray.push({id: "NKgHAojT9", name: "Affiliate Id", value: null});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "mdZU_5FwjxP", "079e99fcc750bad75fdc3cc95cc07fb0a9af6669ad9a838194801f2b3fbac28e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Game Initialized", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("mdZU_5FwjxP", "Game Initialized", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Game Initialized': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Game Initialized", eventProperties, "mdZU_5FwjxP", "079e99fcc750bad75fdc3cc95cc07fb0a9af6669ad9a838194801f2b3fbac28e");
    }
    // destination Softgames
    Softgames.logEvent("Game Initialized", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PurchaseFinishedProperties {
  productId: string;
  transactionId: string | null | undefined;
  currencyCode: string;
  productPrice: string;
  errorMessage: string | null | undefined;
  sandboxPurchase: boolean | null | undefined;
  purchaseResponse: PurchaseResponseValueType;
  purchaseReceipt: string | null | undefined;
  paymentProvider: PaymentProviderValueType;
  storeEntryPoint: string | null | undefined;
  productPriceAmount: number;
  productType: ProductTypeValueType;
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  gameArea: string | null | undefined;
}
/**
 * Purchase Finished: Fires when a transaction completed
 *
 * @param properties the properties associatied with this event
 * @param properties.productId: The ID of the IAP as defined in the respective store
 * @param properties.transactionId: Unique transaction identifier for a single purchase within the IAP process, e.g. the paymentID in case of Facebook.
 * @param properties.currencyCode: 3-digit ISO Currency string of the current purchase
 * @param properties.productPrice: The product price as a string, as defined in the product catalog.
 * @param properties.errorMessage: A message describing why a process failed.
 * @param properties.sandboxPurchase: Boolean value that indicates whether the purchase was real or not (Sandbox Purchases - Test Purchases are flagged here)
 * @param properties.purchaseResponse: String value that indicates whether the purchase was successfully completed or not.

 * @param properties.purchaseReceipt: The purchase receipt as returned by the payment provider. Usually a Base64 encoded SHA256 hash of the payment information, used for server sided receipt validation.
 * @param properties.paymentProvider: Indicates whether the payment was done using Facebook, Google Play, Apple or another service provider
 * @param properties.storeEntryPoint: The specific 'call for action' that led the user to the purchase dialog.
This can provide a more detailed granularity than  Game Area (I.e. focus on an offer popup or a loss aversion popup that led user in the store to make the purchase).
 * @param properties.productPriceAmount: The numeric price of a product
 * @param properties.productType: The Type of the IAP as defined in the respective store
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.gameArea: Area of the game from where the event was triggered
 *
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/Vp5zFmVzDtl}
 */
export function purchaseFinished(properties: PurchaseFinishedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "ZNrRISMpO2", name: "Product Id", value: properties.productId});
  properties.transactionId !== undefined && properties.transactionId !== null ?
    eventPropertiesArray.push({id: "asmftv_hZQ", name: "Transaction Id", value: properties.transactionId}) :
    eventPropertiesArray.push({id: "asmftv_hZQ", name: "Transaction Id", value: null});
  eventPropertiesArray.push({id: "rJSKviH02a", name: "Currency Code", value: properties.currencyCode});
  eventPropertiesArray.push({id: "DMgxIRxK07", name: "Product Price", value: properties.productPrice});
  properties.errorMessage !== undefined && properties.errorMessage !== null ?
    eventPropertiesArray.push({id: "bVayHrru51", name: "Error Message", value: properties.errorMessage}) :
    eventPropertiesArray.push({id: "bVayHrru51", name: "Error Message", value: null});
  properties.sandboxPurchase !== undefined && properties.sandboxPurchase !== null ?
    eventPropertiesArray.push({id: "57h2w2O41", name: "Sandbox Purchase", value: properties.sandboxPurchase}) :
    eventPropertiesArray.push({id: "57h2w2O41", name: "Sandbox Purchase", value: null});
  eventPropertiesArray.push({id: "7x04RYDVr", name: "Purchase Response", value: properties.purchaseResponse});
  properties.purchaseReceipt !== undefined && properties.purchaseReceipt !== null ?
    eventPropertiesArray.push({id: "PwLYdcf3o", name: "Purchase Receipt", value: properties.purchaseReceipt}) :
    eventPropertiesArray.push({id: "PwLYdcf3o", name: "Purchase Receipt", value: null});
  eventPropertiesArray.push({id: "OMHjmD3IF", name: "Payment Provider", value: properties.paymentProvider});
  properties.storeEntryPoint !== undefined && properties.storeEntryPoint !== null ?
    eventPropertiesArray.push({id: "aT-7BjxVF", name: "Store Entry Point", value: properties.storeEntryPoint}) :
    eventPropertiesArray.push({id: "aT-7BjxVF", name: "Store Entry Point", value: null});
  eventPropertiesArray.push({id: "dq_Rj32A3", name: "Product Price Amount", value: properties.productPriceAmount});
  eventPropertiesArray.push({id: "lbtwVEj89", name: "Product Type", value: properties.productType});
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  properties.gameArea !== undefined && properties.gameArea !== null ?
    eventPropertiesArray.push({id: "4552BqnTK8", name: "Game Area", value: properties.gameArea}) :
    eventPropertiesArray.push({id: "4552BqnTK8", name: "Game Area", value: null});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Vp5zFmVzDtl", "50216d26aeef78b78382d7ed26fbede964bae11bfdcaadd28958fd91c33c4376", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Purchase Finished", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Vp5zFmVzDtl", "Purchase Finished", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Purchase Finished': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Purchase Finished", eventProperties, "Vp5zFmVzDtl", "50216d26aeef78b78382d7ed26fbede964bae11bfdcaadd28958fd91c33c4376");
    }
    // destination Softgames
    Softgames.logEvent("Purchase Finished", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdFinishedProperties {
  adType: AdTypeValueType;
  adNetwork: AdNetworkValueType;
  adId: string;
  adPlacementId: string;
  adSlotName: string;
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  adResponse: AdResponseValueType;
  errorMessage: string | null | undefined;
  countRetries: number | null | undefined;
  adShowDelay: number | null | undefined;
}
/**
 * Ad Finished: Fires at the moment when a user finished watching an ad and returns to the game.
 *
 * @param properties the properties associatied with this event
 * @param properties.adType: Ad type
 * @param properties.adNetwork: Name of the ad network provider
 * @param properties.adId: The unique identifier (UUID) of an ad instance, generated on the client side. This is used to track the lifecycle of an ad, starting from the request over preloading and showing an ad.
 * @param properties.adPlacementId: The persistent identifier for an ad placement, as defined by the respective ad network provider like e.g. Facebook or AdMob.
 * @param properties.adSlotName: The unique name for a place (slot) inside the game where an ad is shown. Use this name to compare the performance of ads across the different areas in the game, depending on where they are shown.
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.adResponse: The specific response code how the Ad playback function returned.
 * @param properties.errorMessage: A message describing why a process failed.
 * @param properties.countRetries: Number of retries for a specific action.
 * @param properties.adShowDelay: Waiting time [SECONDS] for the user between the initial call to AdShow and the Ad starting to play. This duration may include the actual network request, potential retries, downloading the ad or falling through to cross promo or final fallback.
 *
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/KZEnBYJPoU}
 */
export function adFinished(properties: AdFinishedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "zlMl3Uf-wQ", name: "Ad Type", value: properties.adType});
  eventPropertiesArray.push({id: "O6mrBfY1FU", name: "Ad Network", value: properties.adNetwork});
  eventPropertiesArray.push({id: "_GaSiwtCM0", name: "Ad Id", value: properties.adId});
  eventPropertiesArray.push({id: "r80Q9aJ8e", name: "Ad Placement Id", value: properties.adPlacementId});
  eventPropertiesArray.push({id: "XO1UyY2x6", name: "Ad Slot Name", value: properties.adSlotName});
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "Rfrle2QVYL", name: "Ad Response", value: properties.adResponse});
  properties.errorMessage !== undefined && properties.errorMessage !== null ?
    eventPropertiesArray.push({id: "bVayHrru51", name: "Error Message", value: properties.errorMessage}) :
    eventPropertiesArray.push({id: "bVayHrru51", name: "Error Message", value: null});
  properties.countRetries !== undefined && properties.countRetries !== null ?
    eventPropertiesArray.push({id: "82maSD1FY", name: "Count Retries", value: properties.countRetries}) :
    eventPropertiesArray.push({id: "82maSD1FY", name: "Count Retries", value: null});
  properties.adShowDelay !== undefined && properties.adShowDelay !== null ?
    eventPropertiesArray.push({id: "xtImei0uE", name: "Ad Show Delay", value: properties.adShowDelay}) :
    eventPropertiesArray.push({id: "xtImei0uE", name: "Ad Show Delay", value: null});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KZEnBYJPoU", "89f43eb51cd75601772e54e3f73ceafac30ced2637cb8b7f03c3816b01ee27f2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Ad Finished", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KZEnBYJPoU", "Ad Finished", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Ad Finished': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Ad Finished", eventProperties, "KZEnBYJPoU", "89f43eb51cd75601772e54e3f73ceafac30ced2637cb8b7f03c3816b01ee27f2");
    }
    // destination Softgames
    Softgames.logEvent("Ad Finished", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CheatsEnabledProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
}
/**
 * Cheats Enabled: Event fired every time a user uses a cheat code.
 *
 * @param properties the properties associatied with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 *
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/DHZGxyro4l}
 */
export function cheatsEnabled(properties: CheatsEnabledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "DHZGxyro4l", "4785a59c558372603105e9107de29bfb936aa14cb0736319301f40b52b1c76a2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Cheats Enabled", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("DHZGxyro4l", "Cheats Enabled", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Cheats Enabled': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cheats Enabled", eventProperties, "DHZGxyro4l", "4785a59c558372603105e9107de29bfb936aa14cb0736319301f40b52b1c76a2");
    }
    // destination Softgames
    Softgames.logEvent("Cheats Enabled", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SOFAResourceActionProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  sofaResourceUpdates: SOFAResourceUpdates[];
  sofaResourceInventory: SOFAResourceInventory[];
  resourceActionTrigger: string;
  levelType: string | null | undefined;
  levelNumber: number | null | undefined;
  gameArea: string;
  resourceActionType: ResourceActionTypeValueType;
}
/**
 * SOFA Resource Action: Fires when a resource is consumed or gained through a sink/source action and the user's inventory was updated.
 *
 * @param properties the properties associatied with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.sofaResourceUpdates: A list of sink/source actions, that affected to amount of Resources in the user's inventory.

Amount should be negative for CONSUMED resources and positive for RECEIVED resources.
 * @param properties.sofaResourceInventory: A list of the current amount of each resource in the user's inventory.
 * @param properties.resourceActionTrigger: The name of the game mechanic that incentivized the user to spend currency or triggered the reward of a resource.
For example spending coins to play another level could be called 'play-level'.
 * @param properties.levelType: The type of the level (i.e. 'saga', 'air-balloon', etc)
 * @param properties.levelNumber: The number of the level
 * @param properties.gameArea: Area of the game from where the event was triggered
 * @param properties.resourceActionType: Denotes the type of sink/source transaction that modified any resource in the user's inventory. For example watching an ad, purchasing an IAP or consuming a booster.
 *
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/_p7vpff_8L}
 */
export function sofaResourceAction(properties: SOFAResourceActionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "-_93HnCW2", name: "SOFA Resource Updates", value: properties.sofaResourceUpdates.map(function(value) { return {
      "SOFA Resource Type": value.sofaResourceType,
      "Amount": value.amount,
    }
  })});
  eventPropertiesArray.push({id: "4tzAI4lGQ", name: "SOFA Resource Inventory", value: properties.sofaResourceInventory.map(function(value) { return {
      "SOFA Resource Type": value.sofaResourceType,
      "Amount": value.amount,
    }
  })});
  eventPropertiesArray.push({id: "yfBdhcxqW", name: "Resource Action Trigger", value: properties.resourceActionTrigger});
  properties.levelType !== undefined && properties.levelType !== null ?
    eventPropertiesArray.push({id: "mlKWvQvTB", name: "Level Type ", value: properties.levelType}) :
    eventPropertiesArray.push({id: "mlKWvQvTB", name: "Level Type ", value: null});
  properties.levelNumber !== undefined && properties.levelNumber !== null ?
    eventPropertiesArray.push({id: "bP1jHNEg5", name: "Level Number", value: properties.levelNumber}) :
    eventPropertiesArray.push({id: "bP1jHNEg5", name: "Level Number", value: null});
  eventPropertiesArray.push({id: "4552BqnTK8", name: "Game Area", value: properties.gameArea});
  eventPropertiesArray.push({id: "KG11eHIZr", name: "Resource Action Type", value: properties.resourceActionType});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    messages = messages.concat(assertSOFAResourceUpdates(properties.sofaResourceUpdates));
    messages = messages.concat(assertSOFAResourceInventory(properties.sofaResourceInventory));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_p7vpff_8L", "975d6f15d3d73b897298a7a98951e239649072a44d83be9709e67941ba3605dd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("SOFA Resource Action", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_p7vpff_8L", "SOFA Resource Action", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'SOFA Resource Action': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SOFA Resource Action", eventProperties, "_p7vpff_8L", "975d6f15d3d73b897298a7a98951e239649072a44d83be9709e67941ba3605dd");
    }
    // destination Softgames
    Softgames.logEvent("SOFA Resource Action", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SOFALevelStartedProperties {
  levelId: string;
  levelGoal: string;
  levelType: string;
  levelAttemptId: string;
  levelNumber: number;
  eventContextSlug: string | null | undefined;
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  levelMoves: number;
}
/**
 * SOFA Level Started: Fires when a user starts playing a level
 *
 * @param properties the properties associatied with this event
 * @param properties.levelId: Unique and persistent identifier of a single level (independent of an attempt)
 * @param properties.levelGoal: The goal of the level (i.e. ALL CARDS,  GOLD CARDS, etc)

 * @param properties.levelType: The type of the level (i.e. 'saga', 'air-balloon', etc)
 * @param properties.levelAttemptId: Unique identifier of a single level attempt (to map Level Started, Level Finished and other events)
 * @param properties.levelNumber: The number of the level
 * @param properties.eventContextSlug: The string identifier of an event context. This can be used to add a common context for a specific event, like a recurring weekly challenge.
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.levelMoves: Amount of moves that are available in the level
 *
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/4S8CS4Z9ek}
 */
export function sofaLevelStarted(properties: SOFALevelStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "YyMk6EdDUR", name: "Level Id", value: properties.levelId});
  eventPropertiesArray.push({id: "H0m49V2ns", name: "Level Goal", value: properties.levelGoal});
  eventPropertiesArray.push({id: "mlKWvQvTB", name: "Level Type ", value: properties.levelType});
  eventPropertiesArray.push({id: "YigUD3Pqm", name: "Level Attempt Id", value: properties.levelAttemptId});
  eventPropertiesArray.push({id: "bP1jHNEg5", name: "Level Number", value: properties.levelNumber});
  properties.eventContextSlug !== undefined && properties.eventContextSlug !== null ?
    eventPropertiesArray.push({id: "7RMHmiFKl", name: "Event Context Slug", value: properties.eventContextSlug}) :
    eventPropertiesArray.push({id: "7RMHmiFKl", name: "Event Context Slug", value: null});
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "ArkiZ3-Ix", name: "Level Moves ", value: properties.levelMoves});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4S8CS4Z9ek", "4566639e3953a327a94922459ac4c129c9671de175255b408a35423733ae8fa0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("SOFA Level Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4S8CS4Z9ek", "SOFA Level Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'SOFA Level Started': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SOFA Level Started", eventProperties, "4S8CS4Z9ek", "4566639e3953a327a94922459ac4c129c9671de175255b408a35423733ae8fa0");
    }
    // destination Softgames
    Softgames.logEvent("SOFA Level Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SOFALevelFinishedProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  levelId: string;
  levelGoal: string;
  levelType: string;
  levelAttemptId: string;
  levelNumber: number;
  eventContextSlug: string | null | undefined;
  levelResult: LevelResultValueType;
  levelScore: number;
  sofaResourceUpdates: SOFAResourceUpdates[] | null | undefined;
  sofaResourceInventory: SOFAResourceInventory[];
  sofaLevelMetricsCount: SOFALevelMetricsCount[];
}
/**
 * SOFA Level Finished: Fires when a user finishes a level
 *
 * @param properties the properties associatied with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.levelId: Unique and persistent identifier of a single level (independent of an attempt)
 * @param properties.levelGoal: The goal of the level (i.e. ALL CARDS,  GOLD CARDS, etc)

 * @param properties.levelType: The type of the level (i.e. 'saga', 'air-balloon', etc)
 * @param properties.levelAttemptId: Unique identifier of a single level attempt (to map Level Started, Level Finished and other events)
 * @param properties.levelNumber: The number of the level
 * @param properties.eventContextSlug: The string identifier of an event context. This can be used to add a common context for a specific event, like a recurring weekly challenge.
 * @param properties.levelResult: The result of the level
 * @param properties.levelScore: User's score at the end of a level
 * @param properties.sofaResourceUpdates: A list of sink/source actions, that affected to amount of Resources in the user's inventory.

Amount should be negative for CONSUMED resources and positive for RECEIVED resources.
 * @param properties.sofaResourceInventory: A list of the current amount of each resource in the user's inventory.
 * @param properties.sofaLevelMetricsCount: A list of customs metrics that were measured during the play through of a SOFA level.
 *
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/1AUGoZXx2b}
 */
export function sofaLevelFinished(properties: SOFALevelFinishedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "YyMk6EdDUR", name: "Level Id", value: properties.levelId});
  eventPropertiesArray.push({id: "H0m49V2ns", name: "Level Goal", value: properties.levelGoal});
  eventPropertiesArray.push({id: "mlKWvQvTB", name: "Level Type ", value: properties.levelType});
  eventPropertiesArray.push({id: "YigUD3Pqm", name: "Level Attempt Id", value: properties.levelAttemptId});
  eventPropertiesArray.push({id: "bP1jHNEg5", name: "Level Number", value: properties.levelNumber});
  properties.eventContextSlug !== undefined && properties.eventContextSlug !== null ?
    eventPropertiesArray.push({id: "7RMHmiFKl", name: "Event Context Slug", value: properties.eventContextSlug}) :
    eventPropertiesArray.push({id: "7RMHmiFKl", name: "Event Context Slug", value: null});
  eventPropertiesArray.push({id: "cUnHplCbL", name: "Level Result ", value: properties.levelResult});
  eventPropertiesArray.push({id: "O2Nd-Jhuq", name: "Level Score", value: properties.levelScore});
  properties.sofaResourceUpdates !== undefined && properties.sofaResourceUpdates !== null ?
    eventPropertiesArray.push({id: "-_93HnCW2", name: "SOFA Resource Updates", value: properties.sofaResourceUpdates.map(function(value) { return {
        "SOFA Resource Type": value.sofaResourceType,
        "Amount": value.amount,
      }
    })}) :
    eventPropertiesArray.push({id: "-_93HnCW2", name: "SOFA Resource Updates", value: null});
  eventPropertiesArray.push({id: "4tzAI4lGQ", name: "SOFA Resource Inventory", value: properties.sofaResourceInventory.map(function(value) { return {
      "SOFA Resource Type": value.sofaResourceType,
      "Amount": value.amount,
    }
  })});
  eventPropertiesArray.push({id: "RyMggSXMA", name: "SOFA Level Metrics Count", value: properties.sofaLevelMetricsCount.map(function(value) { return {
      "SOFA Level Metric": value.sofaLevelMetric,
      "Amount": value.amount,
    }
  })});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    messages = messages.concat(assertSOFAResourceUpdatesOptional(properties.sofaResourceUpdates));
    messages = messages.concat(assertSOFAResourceInventory(properties.sofaResourceInventory));
    messages = messages.concat(assertSOFALevelMetricsCount(properties.sofaLevelMetricsCount));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1AUGoZXx2b", "ff6d75dd3c6a0163ac0fe3ff84298bac68f563604fc05112f7a37f0f35eb0334", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("SOFA Level Finished", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1AUGoZXx2b", "SOFA Level Finished", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'SOFA Level Finished': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SOFA Level Finished", eventProperties, "1AUGoZXx2b", "ff6d75dd3c6a0163ac0fe3ff84298bac68f563604fc05112f7a37f0f35eb0334");
    }
    // destination Softgames
    Softgames.logEvent("SOFA Level Finished", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  GameSlug,
  PurchaseResponse,
  ResourceActionType,
  AdNetwork,
  PaymentProvider,
  AdResponse,
  PlatformName,
  LevelResult,
  BackendName,
  Environment,
  ProductType,
  SchemaVersion,
  SOFALevelMetric,
  SOFAResourceType,
  AdType,
  gameInitialized,
  purchaseFinished,
  adFinished,
  cheatsEnabled,
  sofaResourceAction,
  sofaLevelStarted,
  sofaLevelFinished,
}

// AVOMODULEMAP:"SrcUtilityTrackingAvoAvo"
// AVOEVENTMAP:["gameInitialized","purchaseFinished","adFinished","cheatsEnabled","sofaResourceAction","sofaLevelStarted","sofaLevelFinished"]
